<template>
  <div
    :class="[
      'peer-view-wrapper',
      {
        myself,
        standalone,
        'disabled-video': !enabledVideo
      }
    ]"
  >
    <div class="peer-view-content">
      <video
        :srcObject.prop="enabledVideo ? mediaStream : null"
        class="peer-video"
        autoplay
        muted
        playsinline
      />
      <div class="media-state">
        <v-fa
          @click="onClickMic"
          :icon="enabledMic ? 'microphone' : 'microphone-slash'"
          :class="{ clickable: myself }"
          :size="myself && !standalone ? null : 'lg'"
        />
        <v-fa
          @click="onClickVideo"
          :icon="enabledVideo ? 'video' : 'video-slash'"
          :class="{ clickable: myself }"
          :size="myself && !standalone ? null : 'lg'"
        />
      </div>
      <audio v-if="!myself" :srcObject.prop="mediaStream" autoplay />
    </div>
    <div v-if="!enabledVideo" class="disabled-image">
      <img src="@/assets/images/logo-circle.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PeerView",
  props: {
    myself: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    },
    mediaStream: MediaStream,
    enabledMic: Boolean,
    enabledVideo: Boolean
  },
  methods: {
    onClickMic: function() {
      if (!this.myself) return;
      this.$emit("onClickMic");
    },
    onClickVideo: function() {
      if (!this.myself) return;
      this.$emit("onClickVideo");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.peer-view-wrapper {
  position: relative;
  margin: 0.2rem;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 2px 4px 20px 0 rgba(16, 70, 86, 0.12);

  @media screen and (max-width: 767px) {
    height: 75dvh !important;

    &.myself:not(.standalone) {
      height: 20dvh !important;
      width: auto !important;
      aspect-ratio: 3 / 4;
      position: absolute;
      top: 10px;
      left: 10px;

      .media-state svg {
        margin: 0 7px 5px 0;
      }
    }
  }

  @media screen and (max-height: 667px) {
    height: 70dvh;
  }

  @include mq(md) {
    width: 768px !important;
    height: auto !important;
    aspect-ratio: 4 / 3;

    &.myself:not(.standalone) {
      width: 197px !important;

      .media-state svg {
        margin: 0 10px 7px 0;
      }
    }
  }

  &.myself .media-state {
    opacity: 1;
  }

  &.disabled-video {
    border-radius: 8px;
    background-image: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 0.9)
      ),
      linear-gradient(
        90deg,
        rgba(161, 233, 255, 1) 10.01%,
        rgba(255, 244, 150, 1) 90%
      );
  }

  .peer-view-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .peer-video {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border: 1px solid rgba(5, 37, 46, 0.1);
    border-radius: 8px;
  }

  .disabled-image {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 33%;
    max-height: 80px;
    transform: translate(-50%, -50%);

    img {
      height: 100%;
      width: auto;
    }
  }
}

.media-state {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;
  color: white;
  opacity: 0.5;
  display: flex;
  justify-content: flex-end;

  svg {
    margin: 0 20px 10px 0;
    color: rgba(100, 100, 100, 1);
  }
}
</style>
